<div class="panel d-flex" style="background-color: {{data.notification.color}}" click-stop-propagation>
  <div class="content d-flex p-10">
    <img class="icon w-20 h-20 mt-2" src="{{data.notification.iconUrl}}">
    <div class="body d-flex flex-dir-column w-250 max-w-100p ml-5">
      <div class="header pb-10 mb-10 d-flex justify-content-between align-items-center">
        <span class="header-text fs-16 bold">{{data.notification.headline}}</span>
        <div *ngIf="data.userCanDismiss" class="header-x w-12 h-12 align-items-center justify-content-center pointer" (click)="dismiss()"><i class="i-8 fas fa-times"></i></div>
      </div>
      <div class="info fs-12 mb-10 d-flex flex-dir-column">
        <span class="bold text-ellipsis" title="{{data.notification.title}}">{{data.notification.title}}</span>
        <span class="pt-5">{{data.notification.message}}</span>
      </div>
      <div>
        <a *ngFor="let btn of data.notification.buttons" class="button p-5 fs-12 mr-10 pl-10 pr-10 pointer" (click)="navigateToLink(btn.url)">
          {{btn.label}}
        </a>
      </div>
    </div>
  </div>
</div>
